import { Component, OnInit, Input } from '@angular/core';
import { ShopSettingsService } from '../../services/shop-settings.service';

@Component({
  selector: 'app-navigation-layout',
  templateUrl: './navigation-layout.component.html',
  styleUrls: ['./navigation-layout.component.css']
})
export class NavigationLayoutComponent implements OnInit {

  @Input()
  hideHeader = true;

  @Input()
  hideMain = false;

  @Input()
  hideMenu = false;

  @Input()
  hideNavigation = false;

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit(): void {
  }

  get isVUMode(): boolean {
    return this.shopSettingsService.isVUMode;
  }

  get mainContainerCssClass(): string {
    let result = '';
    result += this.hideHeader ? 'page-container-content' : 'page-container-content-small';
    result += ' ';
    result += this.hideMenu ? 'col-md-12' : 'col-lg-9';
    return result;
  }

}
